import { gql } from "@apollo/client";

export const getHostedLens = gql`
    query getHostedLens($organizationId: ID!, $lensID: ID!) {
        getHostedLens(input: { organizationId: $organizationId, lensId: $lensID }) {
            lens {
                id
                link
                status
                organizationId
            }
        }
    }
`;
